/* eslint-disable */
import axios from '@/axios.js';

export const reviewApi = {
  getReviews(payload) {
    return axios.get('/admin/reviews?isPendingReview=true', {
      params: payload,
    });
  },
  approveReview(id) {
    return axios.post(`/admin/reviews/${id}/approve`);
  },
  rejectReview(id) {
    return axios.post(`/admin/reviews/${id}/reject`);
  }
};
